import {BehaviorSubject, first, timer} from "rxjs";
import {AbstractControl, AsyncValidatorFn} from "@angular/forms";
import {map, switchMap} from "rxjs/operators";
import { ProductService } from "../services/api";

// Validator to check if a version name (version identifier) already exists
export function versionNameValidator(productService: ProductService, data: BehaviorSubject<number>): AsyncValidatorFn {
    return (control: AbstractControl) => {
        // Delay the validation by 700 milliseconds
        return timer(700).pipe(switchMap(() => {
            return productService.getUsedVersionNames(data.getValue()).pipe()
                .pipe(
                    // Check if the control value exists in the list of version names
                    map((versionNames) =>
                        (versionNames.find(versionNames => versionNames == control.value) !== undefined) ? {nameAlreadyExists: true} : null
                    )
                ).pipe(
                    // Complete the observable after the first emission
                    first()
                );
        }))
    };
}
